import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart, getSingleView } from "../../../redux/Cart/Action";
import { CardBody, Modal, ModalHeader, ModalBody } from "reactstrap";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import * as XLSX from "xlsx";
import axiosInstance from "../../../redux/api";
import NormalCardHeader from "../../Common/CardHeader/NormalCardHeader";
import search from "../../../Components/assets/images/search-lg.svg"




const CartList = () => {
  const [params, setParams] = useState({
    page: 1,
    type: 1,
    search_key: "",
    from_date: "",
    to_date: "",
  });
  const [isModalOpen, setModalOpen] = useState(false);

  const cart = useSelector((state) => state.reusableSlice.cartList);
  const singleView = useSelector((state) => state.reusableSlice.singleView);
  const pagination_meta = cart?.pagination_meta;
  const dispatch = useDispatch();

  const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  useEffect(() => {
    dispatch(getAllCart(params));
  }, [dispatch, params]);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const viewComponent = (cart_id) => {
    dispatch(getSingleView(cart_id));
    toggleModal();
  };

  //  csv file convert
  const handleExportCSV = async (e) => {
    e.preventDefault();
  
    const filterParams = {
      ...params,
      page: "",
      from_date:"",
      to_date:"",
       
    };
  
    try {
      const response = await axiosInstance.post(`cart/get_cart_list`, filterParams);
  
      const data = response?.data?.response?.cart_list || [];
  
      if (!data.length) return;
  
      const header = [["Sl", "User Name", "Created On", "Cart Value", "Total Items"]];
  
      const body = data.map((item, index) => [
        index + 1,
        item.user_name,
        item.created_on ? item.created_on.split(" ")[0] : "",
        item.cart_value,
        item.total_items,
      ]);
  
      const worksheet = XLSX.utils.aoa_to_sheet(header);
      XLSX.utils.sheet_add_aoa(worksheet, body, { origin: "A2" });
  
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CartList");
  
      XLSX.writeFile(workbook, "CartList.csv", { bookType: "csv" });
    } catch (error) {
      console.error("Cart Export Error:", error);
    }
  };
  
  return (
    <div className="card-head order-card">
      <div className="sub-head">
        <h4>Cart List</h4>
      </div>
       
      <NormalCardHeader
        params={params}
        setParams={setParams}
        search={search}
      />
      <div className="table-category mt-3">
        <div className="table-first-top d-flex justify-content-end align-items-center">
     
            {/* Filter by
            <select
              onChange={({ target }) =>
                setParams((prevParams) => ({
                  ...prevParams,
                  status: target.value,
                  page: 1,
                }))
              }
            >
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select> */}
            <button className="btn btn-primary" onClick={handleExportCSV}>
              Export CSV
            </button>
        </div>
        <div className="table-sec table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Created on</th>
                <th scope="col">Cart Value</th>
                <th scope="col">Total Items</th>
                <th scope="col" />
              </tr>
            </thead>
            <tbody>
              {cart?.cart_list?.map((item) => (
                <tr key={item.cart_id}>
                  <td>{item.user_name}</td>
                  <td>{item.created_on.split(" ")[0]}</td>
                  <td>₹{item.cart_value}</td>
                  <td>{item.total_items}</td>
                  <td>
                    <button
                      className="background-button"
                      onClick={() => viewComponent(item.cart_id)}
                    >
                      <span>
                        <i className="fa fa-eye"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Bootstrap Modal */}
      <Modal isOpen={isModalOpen} className="cart-modal" toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Cart Details</ModalHeader>
        <ModalBody>
          {singleView ? (
            <div className="table-category">
              <div className="table-first-top d-flex justify-content-between align-items-center">
                <h4 style={{ fontSize: "18px" }}>Cart Items</h4>
                <div className="d-flex justify-content-end align-items-center table-right">
                  <h6>Total items: {singleView.items?.length}</h6>
                </div>
              </div>
              <div className="table-sec table-responsive">
                <table className="table">
                  <thead>
                    <th>Product</th>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th>Price</th>
                  </thead>
                  <tbody>
                    {singleView.items?.map((item) => (
                      <tr key={item.product_name}>
                        <td>
                          <img src={item.image} height={"40px"} alt="" />
                        </td>
                        <td>
                          {" "}
                          <h5>{item.category_name}</h5>
                          <h6>{item.product_name}</h6>
                        </td>
                        <td>{item.quantity}</td>
                        <td>₹{item.final_price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className=" modal-total mt-4">
                <h6>
                  <span>Sub Total</span>
                  {singleView.total_cost_excluding_vat}
                </h6>
                <h6>
                  <span>VAT</span>
                  {singleView.vat_value}
                </h6>
                <h6>
                  <span>Total</span>
                  {singleView.final_price}
                </h6>
              </div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </ModalBody>
      </Modal>
      {/* Pagination Component */}
      <div className="pagination-section">
        {pagination_meta && (
          <CommonPagination
            currentPage={pagination_meta.current_page}
            totalPages={pagination_meta.pages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default CartList;
